import AppointmentComment from './AppointmentComment';
export default AppointmentComment;
